import styled from "styled-components";
import { Small } from "@/lib/styles";

export const WishListDescription = styled.div`
  padding-left: 1rem;
  font-family: ${({ theme }) => theme.fontFamilies.secondary};
  width: 100%;

  ${({ theme }) => theme.mediaQueries.desktop} {
    padding-left: 2.5rem;
  }
`;

export const WishListMedia = styled.a`
  width: 87px;
  flex: none;

  ${({ theme }) => theme.mediaQueries.desktop} {
    width: 137px;
  }
`;

export const WishListProduct = styled.div`
  width: 100%;
  padding: 16px;
  background-color: ${({ theme }) => theme.colors.white};
  display: flex;
  & + & {
    margin-top: 16px;
  }
`;

export const WSProductLabel = styled(Small)`
  display: block;
  margin-bottom: 1rem;
`;

export const WSProductRemoveLabel = styled(Small)`
  display: block;
  color: ${({ theme }) => theme.colors.red};
  cursor: pointer;
`;

export const WSProductTitle = styled.a`
  display: block;
  font-size: 1.25rem;
  line-height: 1.5rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  text-decoration: none;
  color: ${({theme}) => theme.colors.black};
  font-family: ${({ theme }) => theme.fontFamilies.secondary};
`;
